export interface ClinicianDisplayNameParts {
  // User fields come from the login profile; clinician fields come from the
  // optional linked provider record used for credentialed display names.
  user_first_name: string;
  user_last_name: string;
  clinician_first_name?: string | null;
  clinician_last_name?: string | null;
  clinician_credentials?: string | null;
}

const getFullName = (
  firstName?: string | null,
  lastName?: string | null
): string => (firstName && lastName ? `${firstName} ${lastName}` : '');

export const getClinicianDisplayName = (
  clinician: ClinicianDisplayNameParts
): string => {
  const displayName =
    getFullName(
      clinician.clinician_first_name,
      clinician.clinician_last_name
    ) || getFullName(clinician.user_first_name, clinician.user_last_name);
  const credentials = clinician.clinician_credentials?.trim();

  if (!credentials) {
    return displayName;
  }

  return displayName ? `${displayName}, ${credentials}` : credentials;
};
